import zhCN from './zh-CN'
import enUS from './en-US'

export default {
    zhCN,
    enUS
}
